
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp,  faExternalLinkAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Nav, Card, Image, Button, Table, ProgressBar, Pagination, Spinner, Modal, Form, Alert } from '@themesberg/react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { BASE_URL } from '../constants';
import axios from 'axios';
import { Routes } from "../routes";
import { pageVisits, pageTraffic, pageRanking } from "../data/tables";
import transactions from "../data/transactions";
import commands from "../data/commands";
import RoomDetails from "../components/RoomDetails";
import { useAuth } from './../Context/AuthContext';
import moment from 'moment';
const ValueChange = ({ value, suffix }) => {
  const valueIcon = value < 0 ? faAngleDown : faAngleUp;
  const valueTxtColor = value < 0 ? "text-danger" : "text-success";

  return (
    value ? <span className={valueTxtColor}>
      <FontAwesomeIcon icon={valueIcon} />
      <span className="fw-bold ms-1">
        {Math.abs(value)}{suffix}
      </span>
    </span> : "--"
  );
};

export const RoomAvailabilityTable = () => {
  const { user } = useAuth();
  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate();
  const displayedRooms = [...rooms]
  .sort((a, b) => b.freePlaces - a.freePlaces)
  .slice(0, 5);

  const shelterId = user?.shelter?.id;



  useEffect(() => {
    const fetchAvailableRooms = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/accommodation/available-rooms/${shelterId}`);
        if (response.data && response.data.rooms) {
          setRooms(response.data.rooms);
        }
      } catch (error) {
        console.error("Error fetching available rooms:", error);
      }
    };

    if (shelterId) {
      fetchAvailableRooms();
    }
  }, [shelterId]);

  return (
    <Card border="light" className="shadow-sm rounded-4 border-0">
<Card.Header className="bg-white border-bottom" style={{ borderColor: '#dee2e6' }}>
  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
    {/* Left side */}
    <div>
      <h5 className="fw-semibold mb-1">Available Rooms</h5>
      <small className="text-muted">Top 5 rooms offering the most free places</small>
    </div>

    {/* Right side */}
    <Button
      variant="cyan"
      size="sm"
      onClick={() => navigate("/admin/rooms")}
      className="mt-1 mt-sm-0"
    >
      See All
    </Button>
  </div>
</Card.Header>


    <Table
  responsive
  className="align-middle mb-0 custom-room-table"
  style={{ borderCollapse: 'separate', borderSpacing: '0 12px' }}
>

<thead>
  <tr>
    <th className="fw-bold">Room</th>
    <th className="fw-bold">Capacity</th>
    <th className="fw-bold">Occupied</th>
    <th className="fw-bold">Free</th>
  </tr>
</thead>

      <tbody>
        {rooms.length === 0 ? (
          <tr>
            <td colSpan="4" className="text-center text-muted">No available rooms</td>
          </tr>
        ) : (
          displayedRooms.map((room) => (
            <tr key={room._id}>
              <td>{room.roomNumber}</td>
              <td>{room.capacity}</td>
              <td>{room.occupantCount}</td>
              <td>
              <span className="fw-semibold text-danger">
  {room.freePlaces}
</span>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  </Card>
  
  );
};

export const PageTrafficTable = () => {
  const TableRow = (props) => {
    const { id, source, sourceIcon, sourceIconColor, sourceType, category, rank, trafficShare, change } = props;

    return (
      <tr>
        <td>
          <Card.Link href="#" className="text-primary fw-bold">{id}</Card.Link>
        </td>
        <td className="fw-bold">
          <FontAwesomeIcon icon={sourceIcon} className={`icon icon-xs text-${sourceIconColor} w-30`} />
          {source}
        </td>
        <td>{sourceType}</td>
        <td>{category ? category : "--"}</td>
        <td>{rank ? rank : "--"}</td>
        <td>
          <Row className="d-flex align-items-center">
            <Col xs={12} xl={2} className="px-0">
              <small className="fw-bold">{trafficShare}%</small>
            </Col>
            <Col xs={12} xl={10} className="px-0 px-xl-1">
              <ProgressBar variant="primary" className="progress-lg mb-0" now={trafficShare} min={0} max={100} />
            </Col>
          </Row>
        </td>
        <td>
          <ValueChange value={change} suffix="%" />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">#</th>
              <th className="border-0">Traffic Source</th>
              <th className="border-0">Source Type</th>
              <th className="border-0">Category</th>
              <th className="border-0">Global Rank</th>
              <th className="border-0">Traffic Share</th>
              <th className="border-0">Change</th>
            </tr>
          </thead>
          <tbody>
            {pageTraffic.map(pt => <TableRow key={`page-traffic-${pt.id}`} {...pt} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export const RankingTable = () => {
  const TableRow = (props) => {
    const { country, countryImage, overallRank, overallRankChange, travelRank, travelRankChange, widgetsRank, widgetsRankChange } = props;

    return (
      <tr>
        <td className="border-0">
          <Card.Link href="#" className="d-flex align-items-center">
            <Image src={countryImage} className="image-small rounded-circle me-2" />
            <div><span className="h6">{country}</span></div>
          </Card.Link>
        </td>
        <td className="fw-bold border-0">
          {overallRank ? overallRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={overallRankChange} />
        </td>
        <td className="fw-bold border-0">
          {travelRank ? travelRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={travelRankChange} />
        </td>
        <td className="fw-bold border-0">
          {widgetsRank ? widgetsRank : "-"}
        </td>
        <td className="border-0">
          <ValueChange value={widgetsRankChange} />
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">Country</th>
              <th className="border-0">All</th>
              <th className="border-0">All Change</th>
              <th className="border-0">Travel & Local</th>
              <th className="border-0">Travel & Local Change</th>
              <th className="border-0">Widgets</th>
              <th className="border-0">Widgets Change</th>
            </tr>
          </thead>
          <tbody>
            {pageRanking.map(r => <TableRow key={`ranking-${r.id}`} {...r} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};



export const RefugesTable = ({ searchQuery }) => {
  const [refugees, setRefugees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [selectedRole, setSelectedRole] = useState('all');
  const { user } = useAuth();
  const navigate = useNavigate();
  const shelterId = user?.shelter?.id;

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const fetchRefugees = async (role = 'all') => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/refugees/shelter/${shelterId}`);
      let filteredData = response.data;

      if (role === 'isAdmin') filteredData = filteredData.filter(r => r.isAdmin);
      else if (role === 'isRefugee') filteredData = filteredData.filter(r => r.isRefugee);
      else if (role === 'isVolunteer') filteredData = filteredData.filter(r => r.isVolunteer);
      else if (role === 'isNGO') filteredData = filteredData.filter(r => r.isNGO);

      setRefugees(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRefugees(selectedRole);
  }, [selectedRole]);

  const filteredRefugees = refugees.filter((refugee) =>
    [refugee.identifiant, refugee.firstName, refugee.lastName, refugee.email]
      .join(' ')
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleEdit = (refugee) => {
    setEditForm(refugee);
    setShowEditModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    const updatedData = {
      ...editForm,
      dateOfBirth: moment(editForm.dateOfBirth).toISOString(),
    };
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${BASE_URL}/users/${editForm._id}`,
        updatedData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        setRefugees((prev) =>
          prev.map((r) => (r._id === editForm._id ? { ...r, ...updatedData } : r))
        );
        setAlertMessage('User updated successfully!');
        setShowAlert(true);

        setTimeout(() => {
          setShowAlert(false);
          setShowEditModal(false);
        }, 3000);
      } else {
        console.warn('Update failed with status:', response.status);
      }
    } catch (error) {
      console.error('Error updating user:', error);
      alert('Failed to update user details. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const deleteRefugee = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${BASE_URL}/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        setRefugees((prev) => prev.filter((ref) => ref._id !== id));
      
      } else {
        console.warn('Delete request failed with status:', response.status);
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      alert('Failed to delete user. Please try again.');
    }
  };

 const totalPages = Math.ceil(filteredRefugees.length / itemsPerPage);
  const currentRefugees = filteredRefugees.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
   
      {loading ? (
        <div className="text-center my-4">
        <Spinner animation="border" role="status" />
      </div>
      ) : filteredRefugees.length > 0 ? (
        <Card border="light" className="shadow-sm mt-3">
          <Card.Body className="pt-0">
            <Table hover className="user-table align-items-center">
              <thead>
                <tr>
                  <th>Identifiant</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
  {currentRefugees.length === 0 ? (
    <tr>
      <td colSpan="5" className="text-center">No refugees available</td>
    </tr>
  ) : (
    currentRefugees.map((refugee) => (
      <tr key={refugee._id}>
          <td>{refugee.identifiant}</td>
        <td>
          <div className="d-flex align-items-center">
            
           
           
            <div className="ms-3">
            <p className="fw-bold mb-1">
  {refugee.firstName && refugee.lastName
    ? `${refugee.firstName} ${refugee.lastName}`
    : "-"}
</p>

            </div>
          </div>
        </td>
        <td>{refugee.email || '-'}</td>
        <td>{refugee.phone || '-'}</td>
        <td>
          {!refugee.isAdmin && (
            <>
              <Button
                className="me-2 btn-primary btn-sm"
                onClick={() => handleEdit(refugee)}
              >
                <FaEdit />
              </Button>
              <Button
                className="btn-danger btn-sm"
                onClick={() => {
                  if (
                    window.confirm('Are you sure you want to delete this user?')
                  ) {
                    deleteRefugee(refugee._id);
                  }
                }}
              >
                <FaTrash />
              </Button>
            </>
          )}
        </td>
      </tr>
    ))
  )}
</tbody>

            </Table>
            <Pagination className="mt-3">
              <Pagination.Prev
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Card.Body>
        </Card>
      ) : (
        <div className="card mt-3">
          <div className="card-body">
            <p className="card-text">Currently, there are no subscribed users.</p>
          </div>
        </div>
      )}

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                value={editForm.firstName || ''}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                value={editForm.lastName || ''}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={editForm.email || ''}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={editForm.phone || ''}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formGender">
              <Form.Label>Gender</Form.Label>
              <Form.Control
                as="select"
                name="gender"
                value={editForm.gender || ''}
                onChange={handleFormChange}
              >
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formDateOfBirth">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={moment(editForm.dateOfBirth).format('YYYY-MM-DD')}
                onChange={handleFormChange}
              />
            </Form.Group>
          </Form>
          {isLoading && <div className="text-center mt-3">Saving changes...</div>}
          {showAlert && <Alert variant="success">{alertMessage}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


export const RoomsTable = ({ searchQuery }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [newRoom, setNewRoom] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [occupants, setOccupants] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
   const [successMessage, setSuccessMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [selectedOccupants, setSelectedOccupants] = useState([]);
  const [capacityExceeded, setCapacityExceeded] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const shelterId = user.shelter.id;
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [editForm, setEditForm] = useState({
    roomNumber: "",
    occupant: {
      firstName: "",
      lastName: "",
    },
    isOccupied: false,
    capacity: "",
  });

// Fetch occupants

const fetchOccupants = async () => {
  setLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/refugees/shelter/${shelterId}`);
    const refugees = response.data.filter(user => user.isRefugee);
    

    // Apply search filter
    const filteredOccupants = refugees.filter((refugee) => { 
      return (
        refugee.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || 
        refugee.lastName.toLowerCase().includes(searchQuery.toLowerCase()) 
      );
    });

    // Set filtered occupants to state
    setOccupants(filteredOccupants);

  } catch (error) {
    console.error("Error fetching occupants data:", error);
  } finally {
    setLoading(false);
  }
};

// Fetch rooms
const fetchRooms = async () => {
  try {
    if (!shelterId) return;
    const response = await axios.get(`${BASE_URL}/accommodation/shelter/${shelterId}`);
    setRooms(response.data.rooms);
  } catch (error) {
    console.error("Error fetching rooms data:", error);
    setError(error.response?.data?.message || "Error fetching rooms");
  } finally {
    setLoading(false);
  }
};

// Fetch data when shelterId changes
useEffect(() => {
  if (shelterId) {
    fetchRooms();
    fetchOccupants();
  }
}, [searchQuery]);


  const handleOpenModal = (room) => {
    setSelectedRoom(room);
    setShowModal(true);
  };



  const handleSelectChange = (selectedOptions) => {
    setSelectedOccupants(selectedOptions);

    setEditForm((prev) => ({
      ...prev,
      isOccupied: selectedOptions.length > 0,
      occupant: selectedOptions.map((option) => ({
        firstName: option.label.split(" ")[0],
        lastName: option.label.split(" ")[1],
        _id: option.value,
      })),
    }));
  };

  const occupantOptions = occupants.map((occupant) => ({
    value: occupant._id,
    label: `${occupant.firstName} ${occupant.lastName}`,
  }));

  const handleEdit = (room) => {
    setEditForm({
      _id: room._id,
      roomNumber: room.roomNumber,
      occupant: room.occupant || [],
      isOccupied: room.isOccupied,
      capacity: room.capacity,
    });

    setSelectedOccupants(
      room.occupant?.map((o) => ({
        value: o._id,
        label: `${o.firstName} ${o.lastName}`,
      })) || []
    );

    setShowEditModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "isOccupied") {
      const isOccupied = value === "true";
      setEditForm((prev) => ({
        ...prev,
        isOccupied: isOccupied,
        occupant: isOccupied ? prev.occupant : { firstName: "", lastName: "" },
      }));
    } else if (name.startsWith("occupant.")) {
      const key = name.split(".")[1];
      setEditForm((prev) => {
        const newOccupant = { ...prev.occupant, [key]: value };
        return {
          ...prev,
          occupant: newOccupant,
          isOccupied: newOccupant.firstName && newOccupant.lastName ? true : prev.isOccupied,
        };
      });
    } else {
      setEditForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSaveChanges = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('userData'));
      const token = localStorage.getItem('token');

      if (!user || !user.isAdmin) {
        setAlertMessage('You do not have permission to perform this action.');
        setAlertVariant('danger');
        setShowAlert(true);
        return;
      }

      const updatedRoom = {
        roomNumber: editForm.roomNumber,
        capacity: editForm.capacity,
        occupant: editForm.occupant,
        isOccupied: editForm.isOccupied,
      };

      await axios.put(
        `${BASE_URL}/accommodation/${editForm._id}`,
        updatedRoom,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setRooms((prev) =>
        prev.map((room) =>
          room._id === editForm._id ? { ...editForm, _id: room._id } : room
        )
      );
      await fetchRooms(); // re-fetch the latest room data from backend

      setAlertMessage('Room updated successfully!');
      setAlertVariant('success');
      setShowAlert(true);

      setTimeout(() => {
        setShowEditModal(false);
      }, 2000);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again later.';
      if (error.response) {
        errorMessage = error.response.data.message || 'Failed to update room.';
      } else if (error.request) {
        errorMessage = 'No response from server. Please check your connection.';
      }

      setAlertMessage(errorMessage);
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  const indexOfLastRoom = currentPage * itemsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - itemsPerPage;
  const currentRooms = rooms.slice(indexOfFirstRoom, indexOfLastRoom);
  const totalPages = Math.ceil(rooms.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {loading ? (
        <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status" />
      </div>
      ) : rooms.length > 0 ? (
        <Card border="light" className="shadow-sm mt-3" style={{ maxHeight: "500px" }}>
          <Card.Body className="pt-0">
            <Table hover responsive>
              <thead>
                <tr>
                  <th scope="col">Room Number</th>
                  <th scope="col">Capacity</th>
                  <th scope="col">Occupant</th>
                  <th scope="col">Availability Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentRooms.map((room) => {
                  const occupiedPlaces = room.occupant ? room.occupant.length : 0;
                  const freePlaces = room.capacity - occupiedPlaces;
                  const occupancyPercentage = Math.round((occupiedPlaces / room.capacity) * 100);

                  return (
                    <tr key={room._id}>
                      <td><p className="text-muted mb-0">{room.roomNumber}</p></td>
                      <td><p className="text-muted mb-0">{room.capacity}</p></td>
                      <td><p className="text-muted mb-0">
                        {room.occupant && room.occupant.length > 0
                          ? room.occupant.map((o) => `${o.firstName} ${o.lastName}`).join(", ")
                          : "Vacant"}
                      </p></td>
                      <td><p className="text-muted mb-0">{room.isOccupied}</p></td>
                      <td>
                        <Button className="me-2 btn-primary btn-sm" onClick={() => handleEdit(room)}>
                          <FaEdit />
                        </Button>
                        <Button
                          key={room._id}
                          className="me-2 btn-primary btn-sm"
                          onClick={() => handleOpenModal(room)}
                        >
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </Button>

                        <RoomDetails
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          room={selectedRoom}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <Pagination className="mt-3">
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {[...Array(totalPages).keys()].map((page) => (
                <Pagination.Item
                  key={page + 1}
                  active={page + 1 === currentPage}
                  onClick={() => handlePageChange(page + 1)}
                >
                  {page + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Card.Body>
        </Card>
      ) : (
        <div className="card mt-3">
          <div className="card-body">
            <p className="card-text">No rooms available. Please add rooms to proceed.</p>
          </div>
        </div>
      )}

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Room Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formRoomNumber">
              <Form.Label>Room Number</Form.Label>
              <Form.Control
                type="text"
                name="roomNumber"
                value={editForm.roomNumber}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formCapacity">
              <Form.Label>Capacity</Form.Label>
              <Form.Control
                type="text"
                name="capacity"
                value={editForm.capacity}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Occupants</Form.Label>
              <Select
                isMulti
                name="occupants"
                options={occupantOptions}
                value={selectedOccupants}
                onChange={(selectedOptions) => {
                  setSelectedOccupants(selectedOptions);
                  if (selectedOptions.length > editForm.capacity) {
                    setCapacityExceeded(true);
                  } else {
                    setCapacityExceeded(false);
                  }
                  handleSelectChange(selectedOptions);
                }}
                classNamePrefix="react-select"
              />
            </Form.Group>
            <div className="mt-2">
            {showAlert && (
  <Alert
    variant={alertVariant}
    onClose={() => setShowAlert(false)}
    dismissible
    className="mt-3"
  >
    {alertMessage}
  </Alert>
)}

            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={capacityExceeded}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


export const RoomsStateTable = () => {
  const { id } = useParams();
  const [showEditModal, setShowEditModal] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [occupants, setOccupants] = useState([]);
  const [selectedOccupants, setSelectedOccupants] = useState([]);
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [editForm, setEditForm] = useState({
    roomNumber: "",
    occupant: {
      firstName: "",
      lastName: "",
    },
    isOccupied: false,
    capacity: "",
  });
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        // Fetch the shelter data from the API
        const response = await axios.get(`${BASE_URL}/shelters/${id}`);
        
        // Ensure you're extracting the rooms array from the API response
        setRooms(response.data.rooms); // Only store the rooms array in state
      } catch (error) {
        console.error("Error fetching rooms data:", error);
      }
    };
  
    fetchRooms();
  }, [id]);

 
  const handleEdit = (room) => {
    setEditForm({
      _id: room._id,
      roomNumber: room.roomNumber,
      occupant: room.occupant || [],
      isOccupied: room.isOccupied,
      capacity: room.capacity,
    });
  
    setSelectedOccupants(
      room.occupant?.map((o) => ({
        value: o._id,
        label: `${o.firstName} ${o.lastName}`,
      })) || []
    );
  
    setShowEditModal(true);
  };
  


  
  
  
  

  const indexOfLastRoom = currentPage * itemsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - itemsPerPage;

  // Slice the array to display only the rooms for the current page
  const currentRooms = rooms.slice(indexOfFirstRoom, indexOfLastRoom);

  // Calculate total pages
  const totalPages = Math.ceil(rooms.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


 

  return (
    <>
     <Card border="light" className="table-wrapper table-responsive shadow-sm mt-3" style={{ maxHeight: "500px" }}>
        <Card.Body className="pt-0">
          <Table hover className="user-table align-items-center">
      <thead>
        <tr>
        <th scope="col">Room Number</th>
          <th scope="col">Free Places</th>
          <th scope="col">Occupancy Details</th>
          <th scope="col">Capacity</th>
        </tr>
      </thead>
      <tbody>
      {currentRooms.map((room) => {
          const occupiedPlaces = room.occupant ? room.occupant.length : 0; // Total occupied places
          const freePlaces = room.capacity - occupiedPlaces; // Total free places
          const occupancyPercentage = Math.round((occupiedPlaces / room.capacity) * 100); // Occupancy percentage

          return (
            <tr key={room._id}>
              <td>{room.roomNumber}</td>
              <td>
                <div className="d-flex flex-column">
                  <div className="mb-1">
                    {freePlaces}
                  </div>
                </div>
              </td>
              <td>
             
                <div className="d-flex flex-column">
                <div className="mt-1">
                    {occupiedPlaces}/{room.capacity} Occupied
                  </div>
                  {/* Progress bar showing occupancy */}
                  <ProgressBar
                    now={occupancyPercentage}
                    label={`${occupancyPercentage}%`}
                    style={{ height: "10px", fontSize: "0.6rem" }}
                    variant="success"
                  
                  />
            
               
                </div>
              </td>
              <td>{room.capacity}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>


        <Pagination className="mt-3">
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </Pagination.Prev>
          {[...Array(totalPages).keys()].map((page) => (
            <Pagination.Item
              key={page + 1}
              active={page + 1 === currentPage}
              onClick={() => handlePageChange(page + 1)}
            >
              {page + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </Pagination.Next>
        </Pagination>
      </Card.Body>
    </Card>

   
    </>
  );
};


export const CommandsTable = () => {
  const TableRow = (props) => {
    const { name, usage = [], description, link } = props;

    return (
      <tr>
        <td className="border-0" style={{ width: '5%' }}>
          <code>{name}</code>
        </td>
        <td className="fw-bold border-0" style={{ width: '5%' }}>
          <ul className="ps-0">
            {usage.map(u => (
              <ol key={u} className="ps-0">
                <code>{u}</code>
              </ol>
            ))}
          </ul>
        </td>
        <td className="border-0" style={{ width: '50%' }}>
          <pre className="m-0 p-0">{description}</pre>
        </td>
        <td className="border-0" style={{ width: '40%' }}>
          <pre><Card.Link href={link} target="_blank">Read More <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" /></Card.Link></pre>
        </td>
      </tr>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body className="p-0">
        <Table responsive className="table-centered rounded" style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          <thead className="thead-light">
            <tr>
              <th className="border-0" style={{ width: '5%' }}>Name</th>
              <th className="border-0" style={{ width: '5%' }}>Usage</th>
              <th className="border-0" style={{ width: '50%' }}>Description</th>
              <th className="border-0" style={{ width: '40%' }}>Extra</th>
            </tr>
          </thead>
          <tbody>
            {commands.map(c => <TableRow key={`command-${c.id}`} {...c} />)}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};